import { USER_GUIDE_META } from './types';

const PDF_CONTENT_WIDTH_MM = 186;

function normalizePdfLayout(clone: HTMLElement): void {
  clone.querySelectorAll<HTMLElement>('.overflow-x-auto').forEach((node) => {
    node.style.overflow = 'visible';
  });

  clone.querySelectorAll<HTMLElement>('th, td').forEach((node) => {
    node.style.whiteSpace = 'normal';
    node.style.wordBreak = 'break-word';
    node.style.breakInside = 'avoid';
    node.style.pageBreakInside = 'avoid';
  });

  clone.querySelectorAll<HTMLElement>('p, li, figure, table, tr, ul, ol').forEach((node) => {
    node.style.breakInside = 'avoid';
    node.style.pageBreakInside = 'avoid';
  });

  clone.querySelectorAll<HTMLElement>('h2, h3, h4').forEach((node) => {
    node.style.breakAfter = 'avoid';
    node.style.pageBreakAfter = 'avoid';
  });

  // Keep note callouts visually aligned in export.
  clone
    .querySelectorAll<HTMLElement>('div[class*="border-amber-500"], div[class*="bg-amber-500"]')
    .forEach((node) => {
      node.style.textAlign = 'left';
      node.style.lineHeight = '1.5';
    });
}

function preparePdfElement(element: HTMLElement): { container: HTMLDivElement; clone: HTMLElement } {
  const clone = element.cloneNode(true) as HTMLElement;
  const container = document.createElement('div');

  container.style.position = 'fixed';
  container.style.left = '-10000px';
  container.style.top = '0';
  container.style.width = `${PDF_CONTENT_WIDTH_MM}mm`;
  container.style.background = '#ffffff';
  container.style.color = '#111111';
  container.style.zIndex = '-1';

  clone.style.width = '100%';
  clone.style.maxWidth = '100%';
  clone.style.paddingBottom = '32px';
  clone.style.overflow = 'visible';
  normalizePdfLayout(clone);

  container.appendChild(clone);
  document.body.appendChild(container);

  return { container, clone };
}

export async function downloadUserGuidePdf(element: HTMLElement): Promise<void> {
  const html2pdf = (await import('html2pdf.js')).default;
  const { container, clone } = preparePdfElement(element);

  try {
    const options = {
      margin: [12, 12, 18, 12],
      filename: USER_GUIDE_META.pdfFilename,
      image: { type: 'png', quality: 1 },
      html2canvas: {
        scale: Math.max(2, window.devicePixelRatio * 1.5),
        useCORS: true,
        logging: false,
        scrollY: 0,
      },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
      pagebreak: {
        mode: ['css', 'legacy'],
        avoid: ['p', 'li', 'tr', 'td', 'th', 'figure', 'table'],
      },
    };

    await html2pdf()
      .set(options as never)
      .from(clone)
      .save();
  } finally {
    document.body.removeChild(container);
  }
}
